// Elementos DOM
const fromDateElement = document.getElementById('fromDate');
const toDateElement = document.getElementById('toDate');
const fromDateTwoElement = document.getElementById('fromDateTwo');
const toDateTwoElement = document.getElementById('toDateTwo');

// Fecha de hoy
const hoy = new Date();

// Función para obtener una fecha con formato
const getFormattedDate = (date) => {
  const options = { weekday: 'long', day: 'numeric', month: 'long' };
  return new Intl.DateTimeFormat('es-PE', options).format(date);
};

// Función para ajustar fechas si caen en fin de semana
const adjustWeekendDate = (date) => {
  if (date.getDay() === 0) {
    date.setDate(date.getDate() + 1); // Domingo -> Lunes
  } else if (date.getDay() === 6) {
    date.setDate(date.getDate() + 2); // Sábado -> Lunes
  }
  return date;
};

// Calculando las fechas
const dateStartLima = new Date(hoy);
dateStartLima.setDate(hoy.getDate() + 1);
adjustWeekendDate(dateStartLima);

const dateEndLima = new Date(hoy);
dateEndLima.setDate(hoy.getDate() + 2);
adjustWeekendDate(dateEndLima);

// Verificar si las fechas ajustadas son iguales y corregir si es necesario
if (dateStartLima.getTime() === dateEndLima.getTime()) {
  dateEndLima.setDate(dateEndLima.getDate() + 1);
  adjustWeekendDate(dateEndLima);
}

const dateStartProvincia = new Date(hoy);
dateStartProvincia.setDate(hoy.getDate() + 2);
adjustWeekendDate(dateStartProvincia);

const dateEndProvincia = new Date(hoy);
dateEndProvincia.setDate(hoy.getDate() + 3);
adjustWeekendDate(dateEndProvincia);

// Verificar si las fechas ajustadas son iguales y corregir si es necesario
if (dateStartProvincia.getTime() === dateEndProvincia.getTime()) {
  dateEndProvincia.setDate(dateEndProvincia.getDate() + 1);
  adjustWeekendDate(dateEndProvincia);
}

// Actualizando el DOM
fromDateElement.innerHTML = getFormattedDate(dateStartLima);
toDateElement.innerHTML = getFormattedDate(dateEndLima);
fromDateTwoElement.innerHTML = getFormattedDate(dateStartProvincia);
toDateTwoElement.innerHTML = getFormattedDate(dateEndProvincia);


//Eyes

document.addEventListener('DOMContentLoaded', function() {
  startTime();
});

function startTime() {
  const today = new Date();
  const s = today.getSeconds();
  const m = today.getMinutes();
  
  const count = calculateCount(s, m);
  const txtElement = document.getElementById('txt');
  txtElement.innerHTML = `<strong>${Math.round(count)}</strong> personas están viendo este producto`;

  setTimeout(startTime, 500);
}

function calculateCount(s, m) {
  const max = 40;
  const min = 5;
  const range = max - min;

  if (s < 11) {
    return 0.73 * max + m / 10;
  } else if (s < 30) {
    return 0.63 * max + m / 10;
  } else if (s < 45) {
    return min + 0.55 * range + m / 10;
  } else if (s < 51) {
    return 0.89 * range + min - s + 44 + m / 10;
  } else if ([52, 55, 58, 59].includes(s)) {
    return 0.92 * max - s + 54 + m / 10;
  } else {
    return 0.87 * max + m / 10;
  }
}

function checkTime(i) {
  return i < 10 ? `0${i}` : i;
}

//